import React from "react";
import { useTranslation } from "react-i18next";
import { InfoIcon } from "lucide-react";

/**
 * Terracotta callout used on /models and every instrument sub-page. Copy is
 * localised via i18n key `catalogue_callout.body`. The "Note:" prefix is a
 * separate span so we can visually break it on to a new line.
 */
export default function CatalogueCallout({ testid = "catalogue-callout" }) {
  const { t } = useTranslation();
  return (
    <aside
      data-testid={testid}
      className="rounded-xl border border-primary/25 bg-primary/[0.07] p-5 sm:p-6 flex gap-4 items-start"
    >
      <InfoIcon className="h-5 w-5 text-primary shrink-0 mt-0.5" strokeWidth={1.5} />
      <div className="space-y-1.5 text-sm sm:text-base leading-relaxed text-foreground/85">
        <p>{t("catalogue_callout.body")}</p>
        <p className="text-foreground/70">
          <span className="text-[10px] uppercase tracking-[0.22em] text-primary font-medium mr-2">{t("catalogue_callout.note_label")}</span>
          {t("catalogue_callout.custom")}
        </p>
      </div>
    </aside>
  );
}
